(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
  if (!window.__abScrollInit) {
    window.__abScrollInit = true;
    var abIo = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) {
        if (!e.isIntersecting) return;
        var delay = parseInt(e.target.dataset.abDelay || '0', 10);
        setTimeout(function() { e.target.classList.add('ab-visible'); }, delay);
        abIo.unobserve(e.target);
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -48px 0px' });
    function abInit() {
      document.querySelectorAll('[data-ab-animate]').forEach(function(el) { abIo.observe(el); });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', abInit);
    } else {
      abInit();
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["services-content"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var navs = document.querySelectorAll('[data-svc-nav]:not([data-svc-nav-init])');
    navs.forEach(function (nav) {
      nav.setAttribute('data-svc-nav-init', '1');
      var links = nav.querySelectorAll('a[data-svc-tab]');
      var anchors = {};
      links.forEach(function (a) {
        anchors[a.getAttribute('data-svc-tab')] = a;
      });

      var sections = document.querySelectorAll('[data-svc-section]');
      if (!sections.length || !('IntersectionObserver' in window)) return;

      var setActive = function (link) {
        Object.keys(anchors).forEach(function (k) {
          anchors[k].classList.remove('is-active');
          anchors[k].removeAttribute('aria-current');
        });
        link.classList.add('is-active');
        link.setAttribute('aria-current', 'location');
        /* on narrow screens the index scrolls sideways: keep the marked cell in view */
        if (nav.scrollWidth > nav.clientWidth + 1) {
          var cell = link.parentNode;
          var left = cell.offsetLeft - (nav.clientWidth - cell.offsetWidth) / 2;
          nav.scrollLeft = Math.max(0, left);
        }
      };

      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var key = e.target.getAttribute('data-svc-section');
          var link = anchors[key];
          if (!link) return;
          if (e.isIntersecting) setActive(link);
        });
      }, { rootMargin: '-30% 0px -55% 0px', threshold: 0 });

      sections.forEach(function (s) { io.observe(s); });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
